import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CampaignReportPageService {

  public startDate = null;
  public endDate = null;

  public transStartDate = null;
  public transEndDate = null;

  public donStartDatePicker = null;
  public donEndDatePicker = null;

  public donorsStartDatePicker = null;
  public donorsEndDatePicker = null;
  
  constructor() { }
}
